export const selectID = (state: any) => {
  return state?.auth?.user?._id;
};

export const selectVideos = (state: any) => {
  return state?.video?.videos ?? [];
};
export const selectAssets = (state: any) => {
  return state?.asset?.assets ?? [];
};
export const selectMusicAssets = (state: any) => {
  return state?.asset?.musicAssets ?? [];
};
export const getVideoById = (state: any, id: string) => {
  if (id) {
    return state?.video?.videos?.find((video: any) => video._id === id);
  }
};
export const getPageNo = (state: any) => {
  return state.video.page ? state.video.page : 1;
};

export const getVideosLength = (state: any) => {
  return state.video.videos ? state.video.videos.length : 0;
};
export const isLoadMore = (state: any) => {
  return state.video.loadMore;
};
export const isEmailConfigPresent = (state: any) => {
  return state?.email?.emailConfigurations?.length ?? 0;
};
export const selectEmailConfigs = (state: any) => {
  return state?.email?.emailConfigurations ?? [];
};
export const getLogoAssets = (state: any) => {
  return (
    state.asset.assets &&
    state.asset.assets.filter((asset: any) => asset.type === "logo")
  );
};
export const getThumbnailAssets = (state: any) => {
  return (
    state.asset.assets &&
    state.asset.assets.filter((asset: any) => asset.type === "thumbnail")
  );
};

export const selectAgent = (state: any) => {
  return state?.agent?.agent ?? null;
};
export const selectInboxMessages = (state: any) => {
  return state?.agent?.messages ?? [];
};
export const selectDrafts = (state: any) => {
  return state?.agent?.drafts ?? [];
};
export const selectDraftStats = (state: any) => {
  return state?.agent?.stats ?? null;
};
export const selectAvatars = (state: any) => {
  return state?.agent?.avatars ?? [];
};
export const selectAgentTestResult = (state: any) => {
  return state?.agent?.testResult ?? null;
};
